export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="9" fill="#0B1220" />
    <path d="M22.5 10.2A8.2 8.2 0 1 0 22.5 21.8" fill="none" stroke="#F5F4EF" strokeWidth="3.2" strokeLinecap="round" />
    <circle cx="22.6" cy="16" r="2.6" fill="#3B5BFF" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className={`font-display text-[19px] font-bold tracking-[0.14em] ${light ? "text-paper" : "text-ink"}`}>COENZIO</span>
  </span>
);
